import React from 'react';
import PropTypes from 'prop-types';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import Body from '../Components/layout/Body';
import TestDriveDevSidebar from './TestDriveDevSidebar';

const TD_INTERPRET_CHOOSE_HELP = `
  <div>
    <p>
    Your basic choice here is whether or not to do another Test-drive now.   
    </p>
    <p>
    <strong>Why would you do another Test-drive?</strong> 
    The main reason would be that you haven't yet found an access solution that seems to be the best fit for this client.
    In your next Test-drive, you could first adjust the current access method setup, then Test-drive the revised setup to see if it works better than what you've tried so far.  
    Or you might want to try a completely different access device.</p>
    <p>
    <strong>Why would you decline another Test-drive?</strong> Maybe you’ve landed on an access solution that really seems to fit the client’s needs.  
    In that case, you don’t need to keep test-driving at this point. 
    Or maybe you have some ideas for another test-drive, but you’re just out of time for today. 
    You can always come back and do more Test-drives later.     
    </p> 
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  doAnotherTestDrive: PropTypes.string,
  onChangeDoAnotherTestDrive: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  doAnotherTestDrive: '',
};

//content sub-component with unique content for this page
function TestDriveInterpretChooseContent(props) {
  const doAnotherTestDrive = props.doAnotherTestDrive;
  const onChangeDoAnotherTestDrive = props.onChangeDoAnotherTestDrive;

  const anotherTestDriveBtns = [
    {
      value: 'true',
      label: `Yes, let's keep exploring solutions with another Test-drive`,
      moreInfo: ''
    },
    {
      value: 'false',
      label: `No, let's wrap-up for today`,
      moreInfo: ''
    }
  ];

  return(
    <>
    <p>If you want to keep exploring solutions, your basic choices are:</p>
    <ul>
      <li>Adjust the current access device setup, then do another Test-drive to see if that helps</li>
      <li>Test-drive a completely different access device using the same or different body site</li>
    </ul>
    <Form>
      <FormGroup tag="fieldset">
        <legend>Do you want to do another Test-drive now?</legend>
        {anotherTestDriveBtns.map((btn, index) =>
          <FormGroup check key={index}>
            <Input
              id={btn.value}
              value={btn.value}
              checked={doAnotherTestDrive===btn.value}
              onChange={onChangeDoAnotherTestDrive}
              name="do-another-test-drive"
              type="radio"
            />
            {' '}
            <Label for={btn.value} check>
              {btn.label}
              {' '}
            </Label>
          </FormGroup>
        )}
      </FormGroup>
    </Form>

    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function TestDriveInterpretChoose(props) {
  const firstName = props.firstName;
  const doAnotherTestDrive = props.doAnotherTestDrive;
  const onChangeDoAnotherTestDrive = props.onChangeDoAnotherTestDrive;
  const onContinue = props.onContinue;
  const dev = props.dev || {};

  const pageData = {
    image: "",
    faIcon: "",
    pageSymbolClassName: "aa-section-symbol test-drive",
    title: `Choose your next step`,
    subTitle: `Good work! With those considerations in mind, you may now have some ideas for what to do next.`,
    learnMore: {linkText: "Learn More about choosing your next step after a Test-drive",
                title: "Next steps after a Test-drive",
                content: TD_INTERPRET_CHOOSE_HELP
                },
    nextRoute: "", 
    sidebar: false
  }

  console.log("Rendering TestDriveInterpretChoose");
  
  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <TestDriveInterpretChooseContent 
          doAnotherTestDrive={doAnotherTestDrive}
          onChangeDoAnotherTestDrive={onChangeDoAnotherTestDrive}
        />
      } 
      sidebarComponent={
        dev.showDevSidebar 
        &&
        <TestDriveDevSidebar 
          activeTestDriveId={dev.tdId}
          activeTestDrive={dev.td}
          activeTestDriveActivityId={dev.actId}
          activeTestDriveActivities={dev.acts}
          completedTestDrives={dev.ctds}
        />  
      }
      onContinue={onContinue}  
    />
    </>
  );
}

TestDriveInterpretChoose.propTypes = propTypes;
TestDriveInterpretChoose.defaultProps = defaultProps;

export default TestDriveInterpretChoose;